import React, { PureComponent } from 'react'
import eye2 from './eye2.svg'
import styled from 'styled-components'

class Header extends PureComponent {
  render() {
    return (
      <Holder>
        <Nav>
          <Menu>
            <LogoMenu>
              <ImageHolder>
                <EyeImage src={eye2} alt="logo" />
              </ImageHolder>
            </LogoMenu>

            <LogoMenuItem>
              <Link href="/">ФФФ.воркс</Link>
            </LogoMenuItem>

            <LogoMenuItem>
              <Link href="/blog/">Блог</Link>
            </LogoMenuItem>
          </Menu>

          <LinkButton href="https://t.me/fffworks" target="_blank" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path
                id="tg-icon"
                d="M6,11.960784l-1,-3l11,-8l-15.378,5.914c0,0 -0.672,0.23 -0.619,0.655c0.053,0.425 0.602,0.619 0.602,0.619l3.575,1.203l1.62,5.154l2.742,-2.411l-0.007,-0.005l3.607,2.766c0.973,0.425 1.327,-0.46 1.327,-0.46l2.531,-13.435l-10,11zz"
              />
            </svg>&nbsp;<span className="fff-menu-hidden">Подписаться на&nbsp;канал</span>
          </LinkButton>
        </Nav>
      </Holder>
    )
  }
}

const EyeImage = styled.img`
  position: absolute;
  top: -20px;
  width: 52px;
  height: 28px;
`

const Holder = styled.header`
  font-size: 16px;
  padding-left: 9%;
  padding-right: 9%;
  transition: padding-left, padding-right, 0.2s ease-out;

  @media (max-width: 1023px) {
    padding-right: 4%;
    padding-left: 4%;
  }
`

const Nav = styled.nav`
  display: flex;

  justify-content: space-between;
  padding-top: 8px;
  width: 100%;
`

const Menu = styled.div`
  display: inline-block;
  padding-top: 1px;
`

const LogoMenu = styled.div`
  display: inline-block;
`

const ImageHolder = styled.div`
  display: inline-block;
  margin-right: 6px;
  position: relative;
  width: 52px;
`

const LogoMenuItem = styled.div`
  display: inline-block;
  margin-right: 20px;
`

const Link = styled.a`
  color: #125071;
  border-bottom: 1px solid rgba(12, 79, 114, 0.2);
  text-decoration: none;

  &:hover {
    color: #fe5353;
    border-color: #f6c9cb;
  }
`

const LinkButton = Link.extend`
  transition: all 0.2s ease-out;
  text-align: center;
  color: #125071;
  border: 1px solid rgba(12, 79, 114, 0.2);
  text-decoration: none;
  padding: 2px 16px 4px;
  border-radius: 8px;
  white-space: nowrap;
  cursor: pointer;
  position: relative;
  top: -3px;

  svg {
    display: inline-block;
    position: relative;
    top: 2px;
    fill: #125071;
    transition: all 0.2s ease-out;
  }

  &:hover {
    svg {
      fill: #fe5353;
    }
  }
`

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.tsx